<mat-accordion>
    <div class="file-container">
        <mat-card class="file-details mat-elevation-z3 ">
            <section>
                <h3 class="file-details-header">File will be saved locally in (.itn) format</h3>
            </section>
            <br>
            <div mat-dialog-actions>
                <button  mat-raised-button (click)="cancel()">Cancel</button>
                <button mat-raised-button
                        color="warn"
                        class="btn-export"
                        (click)="getExportSaveLocallyFileData()"
                        [disabled]="!displayedWaypoints.length">Save Local</button>
              </div>
        </mat-card>
    </div>
</mat-accordion>